(function () {
  if (typeof window === 'undefined') return;

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const noIO = !('IntersectionObserver' in window);

  const reveal = (el) => el.classList.add('in');
  const revealAll = () => document.querySelectorAll('.reveal:not(.in)').forEach(reveal);

  // Reduced motion or no IntersectionObserver: just reveal everything, now and forever.
  if (reduce || noIO) {
    revealAll();
    new MutationObserver(revealAll).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  const observe = () => document.querySelectorAll('.reveal:not(.in)').forEach((el) => io.observe(el));

  observe();
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:reorder', observe);

  // Re-observe whenever the DOM mutates — this is what catches morphed-in items
  // after a filter/sort re-render, where new <li>s arrive with class="reveal"
  // (no .in) and would otherwise stay at opacity:0 forever. Also catches the
  // case where morph copies new class="reveal" over old class="reveal in",
  // stripping the .in. IntersectionObserver fires synchronously for elements
  // already intersecting, so visible items reveal immediately.
  let pending;
  const scheduleObserve = () => {
    if (pending) return;
    pending = requestAnimationFrame(() => { pending = null; observe(); });
  };
  new MutationObserver(scheduleObserve).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();